// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UL6L9r {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: 16px;
  padding: 16px;
  background: var(--surface-neutral-pale, #fafafa);
  border-radius: 4px;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  height: 74px;
  border: none;
}

.UL6L9r:hover {
  transform: translateY(-2px);
}

.iusBoX {
  background-color: #ffeee5;
}

.i7l_i_ {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 24px;
  flex-shrink: 0;
}

.FZAo13 {
  width: 16px;
  height: 16px;
  border: 1px solid #666666;
  border-radius: 50%;
  transition: all 0.2s ease;
  background-color: transparent;
}

.nevNfk {
  border-color: #d64000;
  background-color: #d64000;
  position: relative;
}

.nevNfk::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background-color: #ffffff;
  border-radius: 50%;
}

.yVr2_J {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  min-width: 0;
  align-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.o3lALE {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ft33qB {
  cursor: pointer;
  display: contents;
}

.zSq5o2 {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.JotKGW {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.n9cFXF,
.A3UFfw {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.n9cFXF:hover,
.A3UFfw:hover {
  background-color: #ffeee5;
  transform: scale(1.1);
}

.LSz6BP {
  color: #d64000;
}

.SeCiK3,
.Gsbzrn {
  width: 16px;
  height: 16px;
}

.jeqxz4 {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ContactItem/ContactItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".contactItem {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: 16px;\n  padding: 16px;\n  background: var(--surface-neutral-pale, #fafafa);\n  border-radius: 4px;\n  width: 100%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  height: 74px;\n  border: none;\n}\n\n.contactItem:hover {\n  transform: translateY(-2px);\n}\n\n.contactItemSelected {\n  background-color: #ffeee5;\n}\n\n.contactItemRadio {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.radioButton {\n  width: 16px;\n  height: 16px;\n  border: 1px solid #666666;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  background-color: transparent;\n}\n\n.radioButtonSelected {\n  border-color: #d64000;\n  background-color: #d64000;\n  position: relative;\n}\n\n.radioButtonSelected::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 6px;\n  height: 6px;\n  background-color: #ffffff;\n  border-radius: 50%;\n}\n\n.contactItemContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 2px;\n  min-width: 0;\n  align-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n}\n\n.contactItemName {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.contactItemLabel {\n  cursor: pointer;\n  display: contents;\n}\n\n.contactItemKey {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contactItemActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.favoriteButton,\n.deleteButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.favoriteButton:hover,\n.deleteButton:hover {\n  background-color: #ffeee5;\n  transform: scale(1.1);\n}\n\n.favoriteButtonActive {\n  color: #d64000;\n}\n\n.favoriteIcon,\n.deleteIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.hiddenCheckbox {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactItem": `UL6L9r`,
	"contactItemSelected": `iusBoX`,
	"contactItemRadio": `i7l_i_`,
	"radioButton": `FZAo13`,
	"radioButtonSelected": `nevNfk`,
	"contactItemContent": `yVr2_J`,
	"contactItemName": `o3lALE`,
	"contactItemLabel": `ft33qB`,
	"contactItemKey": `zSq5o2`,
	"contactItemActions": `JotKGW`,
	"favoriteButton": `n9cFXF`,
	"deleteButton": `A3UFfw`,
	"favoriteButtonActive": `LSz6BP`,
	"favoriteIcon": `SeCiK3`,
	"deleteIcon": `Gsbzrn`,
	"hiddenCheckbox": `jeqxz4`
};
module.exports = ___CSS_LOADER_EXPORT___;
